export default {
    newDesign: true,
    parameters: {
        landing_id: "TrQAnS",
        segment: 11,
    },
    title: " 8–17 yaş arası çocuklar için ücretsiz anime ve çizim deneme dersi | Kodland",
    downtimeUrl: "https://www.kodland.org/tr",
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
        subtitle:
            "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
    },
    quizRotateBySteps: {
        1: {
            question: "Çocuğunuz en çok hangi karakterleri çizmeyi seviyor?",
            answers: [
                "Sevdiği çizgi film kahramanlarını",
                "Kendi hayal ettiği karakterleri",
            ],
            coverImageDesk: {
                url: "/welcome/turkey_anime_start_immediately_desk.png",
            },
            coverImageMob: {
                url: "/welcome/turkey_anime_start_immediately_mob.png",
            },
            isCover: true,
        },
        2: {
            question: "Çocuğunuz en çok ne üretmekten hoşlanır?",
            answers: [
                "🎨 Karakter çizmek ve tasarlamak",
                "🌍 Karakterlerin yaşayacağı dünyalar oluşturmak",
                "🎬 Hikâyeler oluşturmak (animasyon veya çizgi roman)",
                "💻 Logo, web sitesi veya dijital tasarımlar yapmak",
                "🤔 Henüz emin değiliz",
            ],
        },
        3: {
            question: "Çocuğunuzun bilgisayar kullanma becerileri nasıl?",
            answers: [
                "👍 Henüz yeterli bilgisi yok, temel seviyeden başlamalı",
                "🙌 Temel seviyede; PowerPoint ve benzeri uygulamaları kullanabiliyor",
                "🖥️ Orta seviyede; bilgisini daha da geliştirmek istiyor",
                "🎮 Cihazları çoğunlukla oyun oynamak için kullanıyor",
            ],
        },
        4: {
            question: "Şu anda çocuğunuzun gelişiminde sizin için en önemli olan nedir?",
            answers: [
                "🤔 Sosyal ve iletişim becerileri (yumuşak beceriler)",
                "🎓 Gelecekteki kariyerine hazırlık",
                "💻 Ders dışı / ek aktiviteler",
            ],
        },
        5: {
            title: "Çocuğunuz kaç yaşında?",
            subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz.",
            type: "age",
            button: "",
        },
        6: {
            question:
                "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
            answers: [
                "💻 Evet",
                {
                    answer: "☹️ Hayir",
                    stopAnswer: true,
                },
            ],
        },
        7: {
            title: "🎉 Sadece bir adım kaldı!",
            typeInfo: "congrats",
            subtitle:
                "Çocuğunuzun programlama ve dijital tasarım ile yaratıcı yönünü keşfetmesine yardımcı olun.\n\n🌟 200.000'den fazla çocuk bizimle birlikte üretiyor ve öğreniyor.",
            button: "📅 Ücretsiz bir ders ayırtın!",
        },
        8: {
            title: "Ücretsiz ders rezervasyonu yapın",
            type: "one-page-contacts",
            subtitle: "",
            button: "Neredeyse bitti 🔥",
        },
        9: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        10: {
            title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
            button: "Başka neler var?",
        },
        11: {
            title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
            button: "Başka neler var?",
        },
        12: {
            title: "Ders platformumuzda gerçekleşecek 💻",
            typeInfo: "classroom",
            subtitle:
              "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
            button: "Anladım ✅",
        },
    },
};
